import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Dispatch, RootState } from '../../store/store';
import MetaFieldsV2 from '../MetaFieldsV2/MetaFieldsV2';
import { useTranslation } from 'react-i18next';
import React from 'react';

type LocationMetaFieldsProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch>;

const LocationMetaFields: React.FC<LocationMetaFieldsProps> = ({
  metaFields,
  createMetaField,
  deleteMetaField,
  updateListMetaFields,
  setMetaFields,
  getMetaFields,
}) => {
  const { id } = useParams();
  const { t } = useTranslation();

  return (
    <MetaFieldsV2
      id={id}
      metaFields={metaFields}
      createMetaField={createMetaField}
      deleteMetaField={deleteMetaField}
      onChangeListMetaFields={setMetaFields}
      title={t('labels.locationMetaFields')}
      updateListMetaFields={updateListMetaFields}
      getMetaFields={getMetaFields}
    />
  );
};

const mapState = (state: RootState) => ({
  metaFields: state.location_meta_fields.metaFields,
});

const mapDispatch = (dispatch: Dispatch) => ({
  createMetaField: dispatch.location_meta_fields.createMetaField,
  deleteMetaField: dispatch.location_meta_fields.deleteMetaField,
  updateListMetaFields: dispatch.location_meta_fields.updateListMetaFields,
  setMetaFields: dispatch.location_meta_fields.setList,
  getMetaFields: dispatch.location_meta_fields.getMetaFields,
});

export default connect(mapState, mapDispatch)(LocationMetaFields);
